/*
 * Bahimi "Complete your set" — inline size picker for the cart quick-add.
 *
 * The Add button submits through Dawn's <product-form>, which handles the AJAX
 * /cart/add and refreshes the cart drawer / cart page. All this file does is:
 *   - let the customer pick a size (updates the hidden [name=id] the form posts)
 *   - enable the Add button once a size is chosen
 *
 * Uses event delegation on document so it keeps working after the cart drawer
 * or cart page re-renders its markup (which destroys/recreates these nodes).
 *
 * To UNDO: remove the <script> that loads this file (emitted by
 * snippets/bahimi-complete-set.liquid) and delete this file.
 */
(function () {
  if (window.__bhCompleteSetInit) return; // idempotent — safe if loaded twice
  window.__bhCompleteSetInit = true;

  document.addEventListener('click', function (event) {
    var sizeBtn = event.target.closest('.bh-cset__size');
    if (!sizeBtn || sizeBtn.disabled) return;

    var form = sizeBtn.closest('form');
    if (!form) return;

    // Single-select: clear siblings, mark this one.
    form.querySelectorAll('.bh-cset__size').forEach(function (btn) {
      btn.setAttribute('aria-pressed', 'false');
    });
    sizeBtn.setAttribute('aria-pressed', 'true');

    // Point the form's variant input at the chosen size.
    var variantInput = form.querySelector('.bh-cset__vid');
    if (variantInput) variantInput.value = sizeBtn.dataset.vid || '';

    // Enable Add now that a variant is selected.
    var addBtn = form.querySelector('.bh-cset__add');
    if (addBtn) {
      addBtn.disabled = false;
      addBtn.removeAttribute('aria-disabled');
    }
  });
})();
